import { render } from "./tableDetail.vue?vue&type=template&id=1cee41e2&scoped=true"
import script from "./tableDetail.vue?vue&type=script&lang=js"
export * from "./tableDetail.vue?vue&type=script&lang=js"

import "./tableDetail.vue?vue&type=style&index=0&id=1cee41e2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee41e2"]])

export default __exports__